import { Injectable } from '@angular/core';
import { Resident } from 'modules/types';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class ResidentService {
  private resident: Resident[] = null;
  private tableTitle: string;
  private tableSubtitle: string;
  
  constructor(private router: Router) { }

  public get residentList(): Resident[] {
    return this.resident;
  }

  public set residentList(newList: Resident[]) {
    this.resident = newList || null;
  }

  public get title(): string {
    return this.tableTitle;
  }

  public set title(titleText: string) {
    this.tableTitle = titleText || "";
  }

  public get subtitle(): string {
    return this.tableSubtitle;
  }

  public set subtitle(subtitleText: string) {
    this.tableSubtitle = subtitleText || null;
  }

  // This method navigates to the target page and passes the list of residents to be displayed when the page loads.
  // args: target -
  //         the URL of the target page (this can be a path property from the Routes object (e.g., 'home'))
  //       tableTitle -
  //         the title which will appear above the table displaying the set of residents
  //       tableSubtitle -
  //         the subtitle which will appear above the table displaying the set of residents
  //       resident - 
  //         the set of residents to display when the target page loads
  // note: Since this function is called from a bind function, the implicit 'this' refers to the object passed as the
  // first argument provided by the caller (the caller's object's 'residentService' instance, in this case).
  showResidentList(target: string, tableTitle: string, tableSubtitle: string, resident: Resident[]) {
    this.tableTitle = tableTitle;
    this.tableSubtitle = tableSubtitle;
    this.residentList = resident;
    this.router.navigateByUrl(target);
  }

  
}
